import { render } from "./invitation-param.vue?vue&type=template&id=6e011246&scoped=true"
import script from "./invitation-param.vue?vue&type=script&lang=js"
export * from "./invitation-param.vue?vue&type=script&lang=js"

import "./invitation-param.vue?vue&type=style&index=0&id=6e011246&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e011246"]])

export default __exports__